import imagesLoaded from "imagesloaded";

/**
 * Preloads images specified by the CSS selector.
 * @function
 * @param {string} [selector="img"] - CSS selector for target images.
 * @returns {Promise} - Resolves when all specified images are loaded.
 */

const preloadAssets = (selector = "img, video") => {
  const elements = Array.from(document.querySelectorAll(selector));
  
  const promises = elements.map(el => {
    if (el.tagName.toLowerCase() === 'video') {
      // Gestion des vidéos
      return new Promise((resolve) => {
        // Si la vidéo est déjà chargée
        if (el.readyState >= 4) {
          resolve();
        } else {
          el.addEventListener('canplaythrough', resolve, { once: true });
          el.addEventListener('error', resolve, { once: true }); // On résout quand même en cas d'erreur
          el.load();
        }
      });
    } else {
      // Gestion des images (via imagesLoaded)
      return new Promise((resolve) => {
        imagesLoaded(el, { background: true }, resolve);
      });
    }
  });

  return Promise.all(promises);
};

// Exporting utility functions for use in other modules.
export { preloadAssets };
